<template>
  <div :class="[{'vs-sidebar-item-active':activeLink}, {'disabled-item pointer-events-none': isDisabled}]"
       class="vs-sidebar--item" v-if="canSee">
    <router-link v-if="to" :to="to" :class="[{'router-link-active': activeLink}]" :target="target" exact>
      <vs-icon v-if="!featherIcon" :icon-pack="iconPack" :icon="icon">
      </vs-icon>
      <feather-icon :icon="icon" :class="{'w-3 h-3': iconSmall}" v-else></feather-icon>
      <slot></slot>
    </router-link>
    <a v-else :target="target" :href="href">
      <vs-icon v-if="!featherIcon" :icon-pack="iconPack" :icon="icon">
      </vs-icon>
      <feather-icon :icon="icon" :class="{'w-3 h-3': iconSmall}" v-else></feather-icon>
      <slot></slot>
    </a>
  </div>
</template>

<script>
export default {
  name: 'VxSidebarItem',
  props: {
    icon: {
      default: "",
      type: String
    },
    iconSmall: {
      default: false,
      type: Boolean,
    },
    iconPack: {
      default: 'material-icons',
      type: String
    },
    href: {
      default: '#',
      type: String
    },
    to: {
      default: null,
      type: String
    },
    index: {
      default: null,
      type: [String, Number]
    },
    featherIcon: {
      default: true,
      type: Boolean,
    },
    target: {
      default: '_self',
      type: String,
    },
    isDisabled: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      activeLink: false,
    }
  },
  watch: {
    '$route'() {
      this.CheckIsActive()
    }
  },
  methods: {
    CheckIsActive() {
      if (this.to) {
        const resolved = this.$router.match
          ? this.$router.match(this.to)
          : this.$router.resolve(this.to).route

        const targetPath = resolved && resolved.path ? resolved.path : this.to

        if (targetPath === '/') {
          this.activeLink = this.$route.path === '/' || this.$route.path.startsWith('/dashboard')
          return
        }

        const isMatched = this.$route.matched.some((record) => record.path === targetPath)

        this.activeLink = isMatched
      }
    }
  },
  computed: {
    canSee() {
      // this.$acl.check(this.$store.state.userRole);
      // if(this.to) {
      //     return this.$acl.check(this.$router.match(this.to).meta.rule)
      // }
      return true
    }
  },
  updated() {
    this.CheckIsActive();
  }
}
</script>
